import { TagCloud } from "@frank-mayer/react-tag-cloud";
import classNames from "classnames";
import { useSelector } from "react-redux";

function SkillsSphere({ diameter, className }) {
  const { skills } = useSelector((store) => store.app);
  return (
    <div className={classNames("w-max", className)}>
      <TagCloud
        options={{
          radius: diameter / 2,
          maxSpeed: "slow",
          initSpeed: "slow",
          itemClass: "sphere-skill text-sm",
          useHTML: true,
          //   keep: false,
        }}
        onClick={(tag, ev) => window.open(skills[tag], "_blank").focus()}
        // onClickOptions={{ passive: true }}
      >
        {Object.keys(skills)}
      </TagCloud>
    </div>
  );
}

export default SkillsSphere;
